angular.module('app.controllers').controller 'AuthCtrl', [
  '$scope', '$rootScope', '$location', 'UI'
].append (self, root, $location, UI) ->

  params = $location.search()

  if params && angular.isDefined(params.password_restore)
    $location.path("/password-forgot")

  if params && angular.isDefined(params.auth_ticket)
    $location.path("/password-new")

  if params && angular.isDefined(params.confirm)   
    $location.path("/confirm")

  if params && angular.isDefined(params.validated)   
    $location.path("/verification")
    
  return

angular.module('app.controllers').controller 'RegistrationCtrl', [
  '$scope', '$rootScope', 'APIVisitor', '$timeout', '$location', 'APIConfirm', 'smoothScr', 'APICheckEmail', 'UI', '$cookies', 'APICheckin', 'APIEloqua'
].append (self, root, APIVisitor, $timeout, $location, APIConfirm, smoothScr, APICheckEmail, UI, $cookies, APICheckin, APIEloqua) ->
  #  1 - init screen 
  #  2 - confirmed/login
  #  3 - fill data
  #  4 - ticket scan
  
  self.forgotModalEl = document.getElementById('forgotModal')
  self.forgotModal = bootstrap.Modal.getOrCreateInstance(self.forgotModalEl) if self.forgotModalEl


  self.repeatModalEl = document.getElementById('repeatModal')
  self.repeatModal = bootstrap.Modal.getOrCreateInstance(self.repeatModalEl) if self.repeatModalEl

  self.step  = 1 
  self.formProccess = false
  self.formSuccess = false

  self.passType  = true
  self.passType2 = true
  self.togglePass = (pass = true) ->
    return self.passType = !self.passType if pass
    self.passType2 = !self.passType2

  self.setStep = (step) ->
    self.step = step

  APIEloqua.query {lang: 'en'}, (data) ->
    self.initData = angular.copy(data)
    self.resetData(self.initData)
  , (response) ->
    UI.notify false, response.data.error

  self.resetData = (eloqua = [], reset = false) ->

    self.data =
      gender: ""
      first_name: ""
      last_name: ""
      phone: ""

      address: ""
      zip: ""
      city: ""
      country: ""

      company: ""
      position: ""
      email: ""
      password: ""
      
      source: ""
      ticket_category: ""

      locale: "EN"
      shortcode_supplementary: ""

      settings:
        additional_field:
          additional_field_label_1: "Yes, I would like to receive marketing information from Siemens based on my personal interests and give the consent described in detail here"
          additional_field_value_1: false

    self.fake =
      email: ""
      password: ""

    models = 
      salutation: 'gender'
      firstName: 'first_name'
      lastName: 'last_name'
      postCode: 'zip'

    for q, ind in eloqua
      field = q.dvm?.name || q.name
      if field is 'salutation'
        eloqua[ind].values = q.values.map (it) ->
          gender = "null"
          gender = "true" if ['mr.'].some((a) -> it.value.toLowerCase().includes(a))
          gender = "false" if ['ms.'].some((a) -> it.value.toLowerCase().includes(a))
          it.value = gender
          return it

      if field not in ['salutation', 'firstName', 'lastName', 'email', 'country', 'postCode']
        l = (Object.keys(self.data.settings.additional_field).length / 2) + 1
        self.data.settings.additional_field["additional_field_label_#{l}"] = "#{q.title}"
        self.data.settings.additional_field["additional_field_value_#{l}"] = ""

        eloqua[ind].model = "additional_field_value_#{l}"
        eloqua[ind].additional = true
      else
        eloqua[ind].model = models[field] || field
        eloqua[ind].additional = false
      
      eloqua[ind].values.unshift({value: "", name: "- Please select -"}) if q.type is 'choice'


    $timeout () ->
      self.eloqua = angular.copy(eloqua)
    , 100

  self.saveForm = (form) ->
    self.rForm = form
 
  self.register = () ->
    self.formProccess = true

    (new APIVisitor self.data).$save {xlocale: root.lang || 'de'}, (data) ->

      self.done_email = angular.copy(self.data.email)

      self.formProccess = false
      self.formSuccess  = true    
      self.resetData(self.initData)

      self.rForm?.$setPristine()
      self.rForm?.$setUntouched()

      $timeout () -> smoothScr.scroll('#body-top', 0)
      
      self.forgotModal.show()
      
    , (response) ->
      self.formProccess = false
      self.formSuccess  = false

      UI.notify false, response.data.error

  self.checkData = () ->
    console.log self.data

  self.checkEmail = () ->
    self.formProccess = true

    APICheckEmail.get {email: self.data.email, xlocale: root.lang || 'de'}, () ->
      self.formProccess = false
      self.register()
    , (response) ->
      self.formProccess = false

      if response.data.error == "Ein Ticket mit dieser E-Mail-Adresse wurde bereits registriert"
        self.repeatModal.show()
      else
        self.data.email = ''
        UI.notify false, response.data.error


  self.sendLink = () ->
    return unless self.data.email

    self.formProccess = true
    self.formError = false

    (new APICheckin).$save {action: 'password_lost', email: self.data.email, xlocale: root.lang || 'de'}, (data) ->
   
      self.formProccess = false
      self.formSuccess  = true    
      self.resetData(self.initData)

      self.rForm?.$setPristine()
      self.rForm?.$setUntouched()

      self.repeatModal.hide()

    , (response) ->
      self.data.email   = ''
      self.formSuccess  = false
      self.formProccess = false
      self.formError = true if response.data.error != "E-Mail not confirmed"
      UI.notify false, response.data.error


angular.module('app.controllers').controller 'ConfirmCtrl', [
  '$scope', '$timeout', '$location', 'APIConfirm', '$rootScope', 'UI', '$cookies', 'APIActivity'
].append (self, $timeout, $location, APIConfirm, root, UI, $cookies, APIActivity) ->

  self.formProccess  = false    
  self.formSuccess   = false

  params = $location.search()
  
  self.autologin = (data) ->
    self.formProccess = false
    self.formSuccess  = true

    usercookie =
      shortcode:    data.shortcode
      auth_ticket:  data.auth_ticket
      role:         data.role || null
      guest:        false

    $cookies.putObject 'user', usercookie
    
    $location.search('confirm', null)
    $location.search('lang', null)

    root.$emit 'proveSession', true

  if params && angular.isDefined(params.confirm)   
    self.formProccess = true

    APIConfirm.get {hash: params.confirm, xlocale: root.lang || 'de'}, (data) ->

      self.autologin(data)    

    , (response) ->
      self.formProccess = false
      self.formSuccess  = false

      UI.notify false, response.data.error

      $location.search('confirm', null)
      $location.search('lang', null)

      return $location.path("/")

  else
    return $location.path("/")

angular.module('app.controllers').controller 'PasswordCtrl', [
  '$scope', '$rootScope', 'APICheckin', '$timeout', '$location', 'UI', 'APIFavorites', '$translate', '$cookies'
].append (self, root, APICheckin, $timeout, $location, UI, APIFavorites, $translate, $cookies) ->

  self.step = 1

  self.formSuccess = false
  
  self.passType  = true
  self.passType2 = true
  self.togglePass = (pass = true) ->
    return self.passType = !self.passType if pass
    self.passType2 = !self.passType2

  params = $location.search()

  (self.resetData = ->
    self.data = 
      email: ''
      hash: ''
      password: ''

    self.fake = 
      password: ''

    self.formError = false
    self.formProccess = false
  )()

  self.saveForm = (form) ->
    self.fForm = form


  self.autologin = (data) ->

    self.formProccess = false
    self.formSuccess  = true

    usercookie =
      shortcode:    data.shortcode
      auth_ticket:  data.auth_ticket
      role:         data.role || null
      guest:        false

    $cookies.putObject 'user', usercookie
    
    $location.search('confirm', null)
    $location.search('lang', null)

    root.$emit 'proveSession', true, false, true


  self.acceptLogin = () ->
    return unless self.data.email

    self.formProccess = true

    APIFavorites.get {shortcode: self.data.email, entrycode: 'reg'}, (data) ->
      self.formProccess = false
      if data?.shortcode == self.data.email
        self.autologin(data.entrydata)
      else
        $translate('pages.welcome.labels.email').then (trs) ->
          UI.notify false, trs
    , (response) ->
      self.formProccess = true
      UI.notify false, response.data.error



  #
  # Request new password
  #
  
  self.forgotModalEl = document.getElementById('forgotModal')
  self.forgotModal = bootstrap.Modal.getOrCreateInstance(self.forgotModalEl) if self.forgotModalEl

  self.forgotPass = () ->
    return unless self.data.email

    self.formProccess = true
    self.formError = false

    (new APICheckin).$save {action: 'password_lost', email: self.data.email, xlocale: root.lang || 'de'}, (data) ->
      self.resetData()
      self.formSuccess  = true

      self.resetData()

      if self.fForm?
        self.fForm.$setPristine()
        self.fForm.$setUntouched()

      self.forgotModal.show()

    , (response) ->
      self.data.email   = ''
      self.formSuccess  = false
      self.formProccess = false
      self.formError = true if response.data.error != "E-Mail not confirmed"
      UI.notify false, response.data.error


  #
  # Save new password
  #

  if params && angular.isDefined(params.password_restore)
    self.step = 2

    self.data.hash  = params.password_restore
    self.data.email = params.email

  self.savePass = () ->
    return unless self.data.email
    return unless self.data.password
    return unless self.data.hash

    self.formProccess = true

    (new APICheckin self.data).$save {action: 'password_restore', xlocale: root.lang || 'de'}, (data) ->
      self.resetData()
      self.formSuccess = true 
      self.formProccess = false     
    , (response) -> 
      self.formSuccess = false
      self.formProccess = false
      UI.notify false, response.data.error
            
  #
  # Set new password
  #

  if params && angular.isDefined(params.auth_ticket)
    self.step = 3
    self.auth_ticket = params.auth_ticket

  self.setPass = () ->
    return unless self.auth_ticket?
    self.formProccess = true    
    (new APICheckin {password: self.data.password}).$save {_private: true, auth_ticket: self.auth_ticket, xlocale: root.lang || 'de'}, (data) ->
      self.resetData()
      self.formSuccess = true
      self.formProccess = false
    , (response) ->
      self.formSuccess = false
      self.formProccess = false
      UI.notify false, response.data.error

  self.forgotAction = () ->
    if self.step == 1
      self.forgotPass()
    if self.step == 2
      self.savePass()
    if self.step == 3
      self.setPass()

    return
